import React, { useState } from 'react'

const OpcionesTexto = (props) => {
    const { type, id, handleEstilosComponente, styles } = props;
    const [color, setColor] = useState(styles?.colorTitulo)
    return (
        <div >
            <div className='mb-2 d-flex'>
                <textarea defaultValue={styles.texto} rows={16} className='flex-grow-1' onChange={(e) => handleEstilosComponente({ type, id, valor: e.target.value, nombre: 'texto' })} />
            </div>

            <div className='mb-2'>
                <h5>Color</h5>
                <input
                    type="color"
                    id="exampleColorInput"
                    value={color}
                    onChange={(e) => { handleEstilosComponente({ type, id, valor: e.target.value, nombre: 'colorTitulo' }); setColor(e.target.value) }}
                    title="Choose your color"
                />
            </div>
        </div>
    )
}

export default OpcionesTexto